/* Nosotros — el surco que compone. Una sola secuencia manda:
   espera -> saliendo (el disco sale de la funda) -> escribiendo (por palabra)
   -> leyendo (las claves se marcan en celeste) -> girando (las claves caen en
   su propia vertical, el disco las engancha en el canto y las arrastra en
   espiral hasta la mancha, que no crece: absorbe).
   Loop permitido aca (excepcion declarada): un surco gira siempre. */
const { mount, reduced, fontsReady, raf2 } = window.EQ;

mount('[data-eq-nosotros]', (root) => {
  const q = (s) => root.querySelector(s);
  const qa = (s) => Array.from(root.querySelectorAll(s));
  const lento = reduced();
  const S = { fase: 'espera', t: 0, vel: 1, frenado: false, timers: [], raf: 0, ultimo: 0, last: 0, geo: null, pos: null, orig: [], viaj: [], corte: null, avisoHecho: false, titAnim: false };
  let io = null, vistos = new WeakSet(), tMo = 0, tFase = 0, avisoN = 0, avisoT = 0, guardTit = 0, guard = 0;

  // las claves son los <em> del parrafo (editable en el editor de temas)
  qa('[data-eq-texto] em').forEach((em) => em.setAttribute('data-eq-clave', '1'));

  // ---- entrada del titulo letra por letra (recorte desde la linea de base) --
  const partirTitulo = (h) => {
    const parte = (nodo) => {
      Array.from(nodo.childNodes).forEach((n) => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          for (const ch of n.nodeValue) {
            if (ch === ' ') { frag.appendChild(document.createTextNode(' ')); continue; }
            const s = document.createElement('span');
            s.setAttribute('data-eq-l', '1');
            s.textContent = ch;
            s.style.display = 'inline-block';
            s.style.willChange = 'transform,clip-path';
            frag.appendChild(s);
          }
          nodo.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !n.hasAttribute('data-eq-l')) parte(n);
      });
    };
    parte(h);
  };
  const letras = () => {
    const h = q('[data-eq-h1]');
    if (!h) return;
    if (!h.querySelector('[data-eq-l]')) partirTitulo(h);
    const sp = h.querySelectorAll('[data-eq-l]');
    if (!sp.length || S.titAnim) return;
    S.titAnim = true;
    const OPEN = 'inset(-16% -6% -22% -6%)';
    sp.forEach((s, i) => {
      s.style.clipPath = OPEN; s.style.transform = 'none'; s.style.opacity = '1';
      if (lento) return;
      s.getAnimations().forEach((a) => a.cancel());
      s.animate([
        { clipPath: 'inset(100% -6% -22% -6%)', transform: 'translateY(0.22em)', opacity: 0.2 },
        { clipPath: OPEN, transform: 'none', opacity: 1 }
      ], { duration: 620, delay: 90 + i * 26, easing: 'cubic-bezier(.16,.9,.24,1)', fill: 'backwards' });
    });
    if (!avisoT) avisoT = setTimeout(llamarPlay, 900);
  };
  const abrirTitulo = () => {
    const el = q('[data-eq-tit]');
    if (!el) return;
    el.style.transition = 'none'; el.style.clipPath = 'inset(-20px)'; el.style.opacity = '1';
    letras();
  };
  // aros que CONVERGEN sobre el boton: cinco emisiones y para
  const llamarPlay = () => {
    if (lento || S.fase !== 'espera' || S.avisoHecho) return;
    const aros = qa('[data-eq-aro]');
    if (!aros.length) return;
    S.avisoHecho = true;
    const emitir = (n) => {
      if (S.fase !== 'espera') return;
      const a = aros[n % aros.length];
      a.getAnimations().forEach((x) => x.cancel());
      a.animate([
        { transform: 'scale(2)', opacity: 0 },
        { transform: 'scale(1.42)', opacity: 0.45, offset: 0.55 },
        { transform: 'scale(1)', opacity: 0 }
      ], { duration: 1500, easing: 'cubic-bezier(.3,0,.5,1)' });
      if (n < 4) avisoN = setTimeout(() => emitir(n + 1), 1700);
    };
    emitir(0);
  };

  // ---- la secuencia ---------------------------------------------------------
  const partirPalabras = () => {
    const zona = q('[data-eq-texto]');
    if (!zona || zona.querySelector('[data-eq-word]')) return;
    const CERRADO = 'inset(100% -6% -22% -6%)';
    const parte = (nodo) => {
      Array.from(nodo.childNodes).forEach((n) => {
        if (n.nodeType === 3) {
          const txt = n.nodeValue;
          if (!txt) return;
          const frag = document.createDocumentFragment();
          txt.split(/(\s+)/).forEach((tk) => {
            if (!tk) return;
            if (/^\s+$/.test(tk)) return void frag.appendChild(document.createTextNode(tk));
            const s = document.createElement('span');
            s.setAttribute('data-eq-word', '1');
            s.textContent = tk;
            s.style.display = 'inline-block';
            s.style.clipPath = CERRADO;
            s.style.opacity = '0';
            s.style.transition = 'clip-path 300ms cubic-bezier(.2,.78,.24,1),opacity 190ms linear';
            s.style.willChange = 'clip-path,opacity';
            frag.appendChild(s);
          });
          nodo.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !n.hasAttribute('data-eq-word') && !n.hasAttribute('data-eq-play')) parte(n);
      });
    };
    parte(zona);
  };
  const abrirPalabra = (s) => { s.style.clipPath = 'inset(-16% -6% -22% -6%)'; s.style.opacity = '1'; };

  const destinoScroll = () => {
    const tit = q('[data-eq-tit]');
    if (!tit) return window.scrollY;
    let top = 0, n = tit;
    while (n) { top += n.offsetTop; n = n.offsetParent; }
    const hd = document.querySelector('.eq-header');
    const h = hd ? hd.offsetHeight : 104;
    const max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    return Math.max(0, Math.min(max, Math.round(top - h - 4)));
  };
  const irAlDisco = () => {
    const dest = destinoScroll(), y0 = window.scrollY, d = dest - y0;
    if (Math.abs(d) < 2) return;
    if (lento) { window.scrollTo(0, dest); return; }
    const t0 = performance.now(), T = 700;
    const paso = (t) => {
      const u = Math.min(1, (t - t0) / T);
      window.scrollTo(0, y0 + d * (1 - Math.pow(1 - u, 3.1)));
      if (u < 1) requestAnimationFrame(paso);
    };
    requestAnimationFrame(paso);
  };

  const poner = () => {
    if (S.fase !== 'espera') return;
    S.fase = 'saliendo';
    clearTimeout(avisoN);
    qa('[data-eq-aro]').forEach((a) => a.getAnimations().forEach((x) => x.cancel()));
    irAlDisco();
    const btn = q('[data-eq-play]');
    if (btn) { btn.style.transition = 'opacity 200ms linear'; btn.style.opacity = '0'; btn.style.pointerEvents = 'none'; }
    partirPalabras();
    qa('[data-eq-reveal-nos]').forEach((el) => { el.style.transition = 'none'; el.style.clipPath = 'inset(-18px)'; el.style.opacity = '1'; });
    layout();
    // el disco sale de la funda: baja y se va descubriendo (recorte movil)
    const st = q('[data-eq-stage]');
    let dur = 0;
    if (st) {
      const sr = st.getBoundingClientRect();
      const rot = q('[data-eq-play] span:last-child');
      const LY = (rot ? rot.getBoundingClientRect().bottom : sr.top - 520) + 34;
      const H = sr.height || 640;
      const d0 = Math.min(-60, LY - H - sr.top);
      st.style.opacity = '1';
      if (lento) { st.style.transform = 'none'; st.style.clipPath = 'none'; }
      else {
        st.getAnimations().forEach((a) => a.cancel());
        st.style.transform = 'none'; st.style.clipPath = 'none';
        const NK = 26, ks = [];
        for (let k = 0; k <= NK; k++) {
          const u = k / NK, e = 1 - Math.pow(1 - u, 3.1), dy = d0 * (1 - e);
          const corte = Math.max(0, LY - (sr.top + dy));
          ks.push({ offset: u, transform: 'translateY(' + dy.toFixed(1) + 'px)', clipPath: 'inset(' + corte.toFixed(1) + 'px 0px 0px 0px)', easing: 'linear' });
        }
        dur = 1550;
        st.animate(ks, { duration: dur, fill: 'backwards' });
      }
    }
    if (lento) {
      qa('[data-eq-word]').forEach(abrirPalabra);
      marcarClaves();
      S.fase = 'girando';
      return;
    }
    tFase = setTimeout(escribir, dur + 620);
  };

  const escribir = () => {
    S.fase = 'escribiendo';
    const sp = qa('[data-eq-word]');
    if (!sp.length) { S.fase = 'girando'; return; }
    const paso = Math.max(40, Number(root.dataset.ritmo) || 150);
    let t = 0;
    S.timers = [];
    sp.forEach((s, i) => {
      S.timers.push(setTimeout(() => abrirPalabra(s), t));
      const txt = s.textContent || '';
      const largo = txt.replace(/[^\wáéíóúñü]/gi, '').length;
      const var_ = 1 + 0.17 * Math.sin(i * 2.399 + 1.7) + 0.09 * Math.sin(i * 1.113);
      t += paso * (0.46 + 0.5 * Math.min(1.6, largo / 6)) * var_;
      if (/[.:!?]$/.test(txt)) t += paso * 5.2;
      else if (/[;]$/.test(txt)) t += paso * 2.6;
      else if (/[,]$/.test(txt)) t += paso * 1.5;
    });
    S.timers.push(setTimeout(() => {
      layout();
      S.fase = 'leyendo';
      requestAnimationFrame(() => requestAnimationFrame(() => {
        marcarClaves();
        S.timers.push(setTimeout(() => { if (S.fase === 'leyendo') marcarClaves(); }, 90));
        S.timers.push(setTimeout(() => {
          apagarClaves();
          S.t = ventaja();
          S.fase = 'girando';
          arrancar();
        }, 520));
      }));
    }, t + 120));
  };

  // las claves se marcan con FONDO celeste (sobre papel la tinta celeste no llega al contraste)
  const marcarClaves = () => {
    const bg = 'color-mix(in srgb, var(--eq-line) 26%, transparent)';
    qa('[data-eq-clave]').forEach((el) => {
      el.style.transition = 'background-color 120ms linear,box-shadow 120ms linear';
      el.style.transitionDelay = '0s';
      el.style.borderRadius = '7px';
      el.style.backgroundColor = bg;
      el.style.boxShadow = '0 0 9px 5px ' + bg;
    });
  };
  const apagarClaves = () => {
    qa('[data-eq-clave]').forEach((o) => {
      o.style.transitionDelay = '0s';
      o.style.transition = 'background-color 300ms linear,box-shadow 300ms linear';
      o.style.backgroundColor = 'transparent';
      o.style.boxShadow = '0 0 9px 5px transparent';
    });
  };

  // ---- registro de bloques: recorte desde la linea de base (sin transform) --
  const abrirBloque = (el) => {
    if (!el || el.style.opacity === '1') return;
    el.style.transition = 'clip-path 420ms cubic-bezier(.65,0,.35,1),opacity 200ms linear';
    el.style.clipPath = 'inset(-18px)'; el.style.opacity = '1';
    if (io) io.unobserve(el);
    clearTimeout(tMo); tMo = setTimeout(layout, 460);
  };
  const revelar = () => {
    if (S.fase === 'espera') {
      const st = q('[data-eq-stage]');
      if (st && st.style.opacity !== '0') st.style.opacity = '0';
      return;
    }
    if (!io) {
      io = new IntersectionObserver((ent) => ent.forEach((x) => { if (x.isIntersecting) abrirBloque(x.target); }), { rootMargin: '0px 0px -8% 0px' });
    }
    qa('[data-eq-reveal-nos]').forEach((el, i) => {
      if (el.style.opacity === '1') return;
      if (lento) return void abrirBloque(el);
      if (vistos.has(el)) return;
      vistos.add(el);
      el.style.transitionDelay = (Math.min(i, 5) * 0.05) + 's';
      io.observe(el);
    });
  };
  const rescate = () => {
    if (S.fase === 'espera') return;
    const h = window.innerHeight || 800;
    qa('[data-eq-reveal-nos]').forEach((el) => {
      if (el.style.opacity === '1') return;
      const r = el.getBoundingClientRect();
      if (r.top < h * 0.96 && r.bottom > -40) abrirBloque(el);
    });
  };

  // ---- viajeros -------------------------------------------------------------
  const leerClaves = () => {
    const capa = q('[data-eq-capa]');
    if (!capa) return;
    const claves = qa('[data-eq-clave]');
    if (capa.children.length === claves.length) return;
    capa.innerHTML = '';
    claves.forEach((el, i) => {
      const s = document.createElement('span');
      s.className = 'eq-nos__w';
      s.setAttribute('data-eq-w', String(i));
      s.textContent = (el.textContent || '').trim();
      capa.appendChild(s);
    });
  };

  const ajustarDisco = (stage) => {
    let top = 0, n = stage;
    while (n) { top += n.offsetTop; n = n.offsetParent; }
    const lado = Math.max(300, Math.min(820, Math.round(window.innerHeight - (top - destinoScroll()) - 22)));
    const v = lado + 'px';
    if (stage.style.maxWidth !== v) stage.style.maxWidth = v;
  };
  const layout = () => {
    const zona = q('[data-eq-zona]'), stage = q('[data-eq-stage]');
    if (!zona || !stage) return;
    ajustarDisco(stage);
    const zr = zona.getBoundingClientRect(), sr = stage.getBoundingClientRect();
    const Sz = Math.min(sr.width, sr.height);
    if (!Sz || !zr.width) return;
    const cx = sr.left - zr.left + sr.width / 2, cy = sr.top - zr.top + sr.height / 2;
    const R = Sz * 0.47, r0 = Sz * 0.12;
    S.geo = { cx, cy, R, r0 };
    S.orig = qa('[data-eq-clave]');
    S.pos = S.orig.map((el) => {
      const rects = el.getClientRects();
      const r = (rects && rects.length ? rects[0] : el.getBoundingClientRect());
      const x = r.left - zr.left + r.width / 2, y = r.top - zr.top + r.height / 2;
      const k = Math.max(-0.985, Math.min(0.985, (x - cx) / R));
      const th = -Math.acos(k);
      let rot = th * 180 / Math.PI + 90;
      while (rot > 90) rot -= 180;
      while (rot < -90) rot += 180;
      rot = Math.max(-34, Math.min(34, rot * 0.52));
      return { x, y, th, rot, cxp: cx + R * Math.cos(th), cyp: cy + R * Math.sin(th) };
    });
    const txt = q('[data-eq-texto]'), capa = q('[data-eq-capa]');
    if (txt) {
      const tr = txt.getBoundingClientRect();
      S.corte = tr.bottom - zr.top;
      if (capa) capa.style.clipPath = 'inset(' + Math.round(S.corte) + 'px -60px 0px -60px)';
    }
    leerClaves();
    S.viaj = qa('[data-eq-w]');
    if (S.orig[0]) { const fs = getComputedStyle(S.orig[0]).fontSize; S.viaj.forEach((el) => { el.style.fontSize = fs; }); }
    if (lento) S.viaj.forEach((el) => { el.style.opacity = '0'; });
  };
  const ventaja = () => {
    const s = S.pos && S.pos[0];
    if (!s || S.corte == null) return 0;
    const den = s.cyp - s.y;
    if (!(den > 1)) return 0;
    const u = Math.max(0, Math.min(1, (S.corte - s.y) / den));
    return Math.max(0, u * 0.26 * ((Number(root.dataset.vuelta) || 22) * 1000) - 240);
  };

  const paso = (ts) => {
    S.raf = requestAnimationFrame(paso);
    S.ultimo = ts;
    if (!S.geo || !S.pos || !S.pos.length) return;
    if (!S.viaj || S.viaj.length !== S.pos.length || !S.viaj[0] || !S.viaj[0].isConnected) {
      layout();
      if (!S.viaj || S.viaj.length !== S.pos.length) return;
    }
    const dt = Math.min(64, ts - (S.last || ts));
    S.last = ts;
    if (S.fase !== 'girando') { S.viaj.forEach((el) => { el.style.opacity = '0'; }); return; }
    const obj = S.frenado ? 0.08 : 1;
    S.vel += (obj - S.vel) * 0.11;
    S.t += dt * S.vel;
    const g = S.geo;
    const T = (Number(root.dataset.vuelta) || 22) * 1000;
    const turns = Number(root.dataset.vueltas) || 2.2;
    const N = S.pos.length;
    const CAIDA = 0.26;
    for (let i = 0; i < N; i++) {
      const el = S.viaj[i], o = S.orig[i], src = S.pos[i];
      if (!el || !src) continue;
      const crudo = (S.t - i * (T / N)) / T;
      if (crudo < 0) { el.style.opacity = '0'; if (o) o.style.opacity = '1'; continue; }
      let p = crudo % 1;
      if (p < 0) p += 1;
      let x, y, sc = 1, op = 1, rot = 0;
      if (p < CAIDA) {
        const u = p / CAIDA;
        x = src.x + (src.cxp - src.x) * (u * u * u);
        y = src.y + (src.cyp - src.y) * u;
        rot = src.rot * Math.pow(u, 2.2);
      } else {
        rot = src.rot + 2 * Math.sin(S.t / 2600 + i);
        const u0 = (p - CAIDA) / (1 - CAIDA);
        const a = g.R, c = (g.r0 - g.R) / 2, K = a + c;
        const u = Math.abs(c) < 0.001 ? u0 : (-a + Math.sqrt(Math.max(0, a * a + 4 * c * K * u0))) / (2 * c);
        const th = src.th + turns * 2 * Math.PI * u;
        const r = g.R + (g.r0 - g.R) * u;
        x = g.cx + r * Math.cos(th); y = g.cy + r * Math.sin(th);
        sc = 1 - 0.4 * u;
        if (u > 0.88) op = Math.max(0, (1 - u) / 0.12);
      }
      el.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) translate(-50%,-50%) rotate(' + rot.toFixed(2) + 'deg) scale(' + sc.toFixed(3) + ')';
      el.style.opacity = op.toFixed(3);
      if (o) {
        let a;
        if (S.corte != null && y < S.corte + 4) a = 1;
        else { const rec = p < 0.45 ? 0 : Math.min(1, (p - 0.45) / 0.5); a = 0.18 + 0.82 * rec; }
        o.style.opacity = a.toFixed(3);
      }
    }
  };
  const arrancar = () => {
    if (lento) return;
    const ahora = performance.now();
    if (S.ultimo && ahora - S.ultimo < 400) return;
    if (S.raf) cancelAnimationFrame(S.raf);
    S.last = 0;
    S.raf = requestAnimationFrame(paso);
  };

  const frenar = () => { if (root.dataset.freno !== 'false') S.frenado = true; };
  const soltar = () => { S.frenado = false; };
  const stage = q('[data-eq-stage]');
  if (stage) { stage.addEventListener('pointerenter', frenar); stage.addEventListener('pointerleave', soltar); }
  q('[data-eq-poner]')?.addEventListener('click', poner);
  const onResize = () => layout();
  window.addEventListener('resize', onResize);

  // entrada del titulo (con red de seguridad) y guard general por medicion
  guardTit = setTimeout(abrirTitulo, 1800);
  if (lento) abrirTitulo();
  else fontsReady().then(raf2).then(abrirTitulo);
  leerClaves(); revelar(); layout(); arrancar();
  guard = setInterval(() => { revelar(); rescate(); layout(); arrancar(); }, 1200);

  return () => {
    window.removeEventListener('resize', onResize);
    if (io) io.disconnect();
    if (S.raf) cancelAnimationFrame(S.raf);
    clearTimeout(guardTit); clearInterval(guard); clearTimeout(tMo); clearTimeout(tFase); clearTimeout(avisoN); clearTimeout(avisoT);
    S.timers.forEach(clearTimeout);
    if (stage) { stage.removeEventListener('pointerenter', frenar); stage.removeEventListener('pointerleave', soltar); }
  };
});
